<ds-modal
  id="addPaymentMethodSuccessModal"
  [closeOthers]="true"
  [fullScreen]="true"
  [maxWidth]="750"
  [showCloseButton]="false"
>
  <ds-confirmation [confirmationData]="confirmationData" variant="modal"> </ds-confirmation>
</ds-modal>
